import {ReactNode, useEffect, useMemo} from "react";
import {
  Container,
  HeaderSection,
  HeaderSubTitle,
  HeaderTitle,
  ListContainer,
} from "../style";
import AdCard from "../../components/commonComponents/adCard";
import Header from "../../components/header";
import SearchAndFilter from "../../components/searchAndFilter";
import CreateBoardModal from "../../components/modals/createBoardModal";
import { SwipeFileReducerAction } from "../../store/swipeFile/slice";
import { useDispatch, useSelector } from "react-redux";
import { FilterOptions, SwipeFileListItems } from "../../store/swipeFile/types";
import { MetaDataSagaActions } from "../../store/metadata/sagas";
import SaveAdPopover from "../../components/saveAdPopover";
import {
  Box,
  CircularProgress,
  Divider,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import {
  BoardItem,
  listType,
  selectFolderBoardItem,
} from "../../store/metadata/types";
import CardListWrapper from "../../components/commonComponents/adCard/cardListWrapper";
import InfiniteScroll from "react-infinite-scroll-component";
import { MetaDataReducerAction } from "../../store/metadata/slice";
import AddToBoardModal from "../../components/modals/addToBoardModal";
import AddTagModal from "../../components/modals/addTagModal";
import { useLocation, useParams } from "react-router-dom";
import {
  boardAdsFilterCountSelector,
  boardAdsItemsSelector,
  boardAdsSearchSelector,
  filterOptionSelector,
  isLoadingSelector,
  selectedBrandsSelector,
  selectedPlatformsSelector,
  selectedTabIndexSelector,
  selectedTagsSelector,
  selectFolderSelector,
  sharedFolderListSelector,
} from "../../store/metadata/selector";
import { FolderIconDark } from "../../assets/Icons";
import { theme } from "../../utils/theme";
import {SwipeFileSagaActions} from "../../store/swipeFile/sagas";
import DeleteAdModal from "../../components/modals/deleteAdModal";

const MyFolder = () => {
  const dispatch = useDispatch();

  const { folderId } = useParams();
  const { pathname } = useLocation();
  const selectedFolder = useSelector(selectFolderSelector);
  const boardAdsItems = useSelector(boardAdsItemsSelector);
  const userDetails = JSON.parse(localStorage.getItem("User") as string);
  const selectedBrands = useSelector(selectedBrandsSelector);
  const selectedTabIndex = useSelector(selectedTabIndexSelector);
  const selectedPlatforms = useSelector(selectedPlatformsSelector);
  const selectedTags = useSelector(selectedTagsSelector);
  const isLoading = useSelector(isLoadingSelector);
  const filterOption = useSelector(filterOptionSelector);
  const boardAdsFilterCount = useSelector(boardAdsFilterCountSelector);
  const searchValue = useSelector(boardAdsSearchSelector);
  const pathKey = pathname.split("/")[1];
  const folderIdValue = pathname.split("/")[2];
  const sharedFolderItems = useSelector(sharedFolderListSelector);

  const content = {
    tabTitle: selectedFolder?.name,
    tabSubTitle: "",
  };

  const setSwipeFileTabIndex = (tabIndex: number) => {
    dispatch(MetaDataReducerAction.setSelectedTabIndex(tabIndex));
    localStorage.setItem("boardTabIndex", String(tabIndex))
    dispatch(MetaDataReducerAction.resetSwipefileState());
    fetchFolderBoardAds(tabIndex);
  };

  const fetchSortingSwipeFileItems = (
    sortValue: string,
    sortObject: Object
  ) => {
      if(filterOption.sortValue !== sortValue){
          dispatch(MetaDataReducerAction.setBoardAdsItems({data:[]}))
          dispatch(MetaDataReducerAction.setFilterOptionSkipValue(0))
      }
    dispatch(
      MetaDataReducerAction.setSelectedSortOption({ sortValue, sortObject })
    );
    dispatch(
      MetaDataSagaActions.fetchFolderList({
        selectedFolderId: folderId ?? folderIdValue,
        selectedTabIndex,
        type: "filter",
      })
    );
  };

  const fetchfilterSwipeFileItems = (
    selectAll: boolean,
    checked: boolean,
    stateName: keyof FilterOptions,
    list: listType[],
    id?: string
  ) => {
    // Reset board ads items and skip value when filters are applied
    dispatch(MetaDataReducerAction.setBoardAdsItems({data: [], total: 0}));
    dispatch(MetaDataReducerAction.setFilterOptionSkipValue(0));

    dispatch(
      MetaDataReducerAction.setSelectedFilterOptions({
        selectAll,
        checked,
        id,
        list,
        stateName,
      })
    );
    dispatch(
      MetaDataSagaActions.fetchFolderList({
        selectedFolderId: folderId ?? folderIdValue,
        selectedTabIndex,
        type: "filter",
      })
    );
  };

  const refetchSwipeFileItem = (adId: string, updatedBoardList: BoardItem,removeBoardIds:string) => {
      const updatedSwipeFileItemData = boardAdsItems?.data?.filter(
          (item: SwipeFileListItems) => {
              const isTargetAd = item?._id === adId;
              const hasMatchingBoard = item?.board?.some((boardItem) =>
                  removeBoardIds?.includes(boardItem?._id) &&
                  boardItem?.folderId === folderId
              );
              if (isTargetAd && hasMatchingBoard) {
                  return false; // remove this item
              }
              return true; // keep other items
          }
      );
      // fetchFolderBoardAds();
      dispatch(MetaDataReducerAction.setBoardAdsItems({data:updatedSwipeFileItemData}))
    dispatch(
      SwipeFileReducerAction.setUpdatedBoardIds({ adId, updatedBoardList })
    );
  };

  const handleClearSwipeFileFilter = () => {
    dispatch(MetaDataReducerAction.resetSwipefileState());

    dispatch(
      MetaDataSagaActions.fetchFolderList({
        selectedFolderId: folderId ?? folderIdValue,
        selectedTabIndex: 0,
      })
    );
  };

  const fetchFolderBoardAds = (tabIndex?: number) => {
      dispatch(MetaDataReducerAction.resetSwipefileState());
    const boardId = selectedFolder?.boards[tabIndex ?? selectedTabIndex]?._id;
    dispatch(
      MetaDataSagaActions.fetchFolderListByBoardId({
        selectedFolderId: folderId ?? folderIdValue,
        selectedTabIndex: tabIndex ?? selectedTabIndex,
        boardId: boardId,
      })
    );
  };

  useEffect(() => {
    fetchFolderBoardAds();
  }, [folderIdValue]);

  // Listen for tab changes from the header
  useEffect(() => {
    // When tab index changes from the header, call fetchBrandLists API with the board ID
    if (selectedTabIndex !== undefined) {
      const selectedBoard = selectedFolder?.boards[selectedTabIndex];
      if (selectedBoard?._id) {
        dispatch(MetaDataSagaActions.fetchBrandLists({ boardId: selectedBoard._id }));
      }
    }
  }, [selectedTabIndex, selectedFolder]);

  // useEffect(() => {
  //   const tabIndex = localStorage.getItem("boardTabIndex");
  //   dispatch(MetaDataReducerAction.setSelectedTabIndex(Number(tabIndex)));
  // })

  useEffect(() => {
    dispatch(MetaDataSagaActions.fetchFavouriteFolderList());
    dispatch(MetaDataSagaActions.fetchFavouriteBrands());
    dispatch(MetaDataSagaActions.fetchBoardList());
    // Get the current board ID if available
    const currentBoardId = selectedFolder?.boards?.[selectedTabIndex || 0]?._id;
    dispatch(MetaDataSagaActions.fetchBrandLists({ boardId: currentBoardId }));
    dispatch(MetaDataSagaActions.fetchTagLists());
    return () => {
      dispatch(MetaDataReducerAction.setBrandFilterSearchText(""));
    };
  }, []);

  const fetchMoreSwipeFileItem = () => {
    dispatch(
      MetaDataSagaActions.fetchFolderList({
        selectedFolderId: folderId ?? folderIdValue,
        selectedTabIndex,
      })
    );
  };

  const handleSearchChange = async (value: string) => {
    if (!value) {
      await dispatch(MetaDataReducerAction.resetSkipLimitValue());
    }
      dispatch(MetaDataReducerAction.setBoardAdsItems({data: [], total: 0}));
    dispatch(MetaDataReducerAction.setBoardAdsSearchValue(value));
    dispatch(
      MetaDataSagaActions.fetchFolderList({
        selectedFolderId: folderId ?? folderIdValue,
        selectedTabIndex,
        type: "filter",
      })
    );
  };

  const hanldeSearchButton = () => {};

  const RenderAdsComponent = useMemo(() => {
    // const totalPages = Math.ceil(boardAdsItems?.total / filterOption?.limit);
    // const currentPage = filterOption?.skip / filterOption?.limit;
      // const myItemsLength = boardAdsItems?.data?.length ?? 0;
      // const hasMoreData = totalPages > currentPage;
      const swipeFileListItemsLength = boardAdsItems?.data?.length ?? 0;
      const hasMoreData = boardAdsItems?.total > swipeFileListItemsLength;


    if (selectedFolder?.boards?.length === 0) {
      return (
        <ListContainer>
          <HeaderTitle textAlign="center">
            Create your first board and Save Ads
          </HeaderTitle>
          <HeaderSubTitle textAlign="center">
            Add Multiple Boards in Folders and enjoy organizing Ads.
          </HeaderSubTitle>
        </ListContainer>
      );
    }

    if (!isLoading && swipeFileListItemsLength === 0) {
      return (
        <>
          <ListContainer>
            <HeaderTitle textAlign="center">
              Your saved Ads will appear here
            </HeaderTitle>
            <HeaderSubTitle textAlign="center">
              Use our extension to save ads from platforms and grow
            </HeaderSubTitle>
          </ListContainer>
        </>
      );
    }

    return (
      <ListContainer>
        <CardListWrapper>
          {boardAdsItems?.data?.map(
            (item: SwipeFileListItems, index: number) => (
              <AdCard
                item={item}
                key={index}
                index={index}
                dataList={boardAdsItems?.data}
                locationPathname={""}
                isBoardAdsData={true}
              />
            )
          )}
          {isLoading &&
            [...Array(4)]?.map((index) => (
              <AdCard item={{} as SwipeFileListItems} key={index} />
            ))}
        </CardListWrapper>
        <InfiniteScroll
            scrollableTarget={document.getElementById('content') as ReactNode}
          dataLength={swipeFileListItemsLength}
          // dataLength={boardAdsItems?.total}
          next={fetchMoreSwipeFileItem}
          hasMore={hasMoreData}
          loader={
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          }
          style={{ overflow: "hidden" }}
          key={swipeFileListItemsLength}
        >
          <></>
        </InfiniteScroll>
      </ListContainer>
    );
  }, [boardAdsItems?.data, boardAdsItems?.total, isLoading, selectedFolder?.boards?.length]);

  const handleTabs = (event: React.SyntheticEvent, newValue: number) => {
    setSwipeFileTabIndex(newValue);
  };

  return (
    <Container>
      <HeaderSection>
        <Header content={content} />
        <SearchAndFilter
          handleFilter={fetchfilterSwipeFileItems}
          selectedBrands={selectedBrands}
          selectedPlatforms={selectedPlatforms}
          handleSortFilter={fetchSortingSwipeFileItems}
          selectedFilterOption={filterOption?.sortValue}
          renderBoardFilter={false}
          searchValue={searchValue}
          handleSearchChange={handleSearchChange}
          hanldeSearchButton={hanldeSearchButton}
          buttonsToShow={["filter", "sort"]}
          filterCounts={boardAdsFilterCount}
          handleClearFilter={handleClearSwipeFileFilter}
          userId={userDetails?._id}
          renderTagFilter={true}
          selectedTags={selectedTags}
          placeholder={`Search in the ${selectedFolder?.name || 'folder'}...`}
        />
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              display: "flex",
              paddingX: "20px",
              gap: "5px",
              alignItems: "center !important",
              justifyContent: "center",
            }}
          >
            <FolderIconDark />
            <Typography
              sx={{ fontSize: "14px", fontWeight: 600, color: "#414042" }}
            >
              Boards:
            </Typography>
          </Box>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{ m: 0 }}
          />
          {selectedFolder?.boards?.length > 0 && (
            <Tabs
              value={selectedTabIndex}
              onChange={handleTabs}
              variant="scrollable"
              scrollButtons={false}
              sx={{
                ".MuiTabs-flexContainer": { gap: "5rem" },
                minHeight: "3rem",
                "& .MuiTabs-scroller": {
                  overflowX: "auto",
                  scrollbarWidth: "none",
                  "-ms-overflow-style": "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  "-webkit-overflow-scrolling": "touch",
                },
              }}
            >
              {selectedFolder?.boards?.map((item: selectFolderBoardItem) => (
                <Tab
                  key={item?._id}
                  label={item?.name}
                  sx={{
                    "&.Mui-selected": {
                      color: theme.colors.blue,
                      borderBottom: "1px solid",
                      fontWeight: "600",
                    },
                    color: theme.colors.gray1,
                    textTransform: "capitalize",
                    paddingBottom: "1rem",
                    minWidth: "fit-content",
                    fontSize: "1rem",
                    minHeight: "3rem",
                  }}
                />
              ))}
            </Tabs>
          )}
          {selectedFolder?.boards?.length === 0 && (
            <Typography
              sx={{ fontSize: "14px", color: "#414042", marginLeft: "8px" }}
            >
              No Boards Found
            </Typography>
          )}
        </Box>

        {RenderAdsComponent}
      </HeaderSection>
      <SaveAdPopover reFetchData={refetchSwipeFileItem} />
      <CreateBoardModal />
      <AddToBoardModal />
      <AddTagModal />
        <DeleteAdModal
            handleDelete={async ()=>{
                await dispatch(SwipeFileSagaActions.deleteAd());
                fetchFolderBoardAds()
            }}
        />
    </Container>
  );
};

export default MyFolder;
